// extracted by mini-css-extract-plugin
export default {"question-policy-holders-search":"styles_question-policy-holders-search__aa0NO","value":"styles_value__wKB44"};